export const questionTypes = {
  nps: "nps",
  recommend: "recommend",
  efficiency: "efficiency",
};
